


















import { Component, Vue, Prop } from 'vue-property-decorator'
import UploadItem from '@/components/upload/Item.vue'
@Component({
  components: {
    UploadItem
  }
})
export default class UploadList extends Vue {
  @Prop({
      type: String,
      default: 'normal',
      required: false
    })
    type!: string
  @Prop({
    type: Array,
    required: true
  })
  list!: object[]

  tryUpload (uid: number) {
    this.$emit('try-upload', uid)
  }
}
